export const DISABLE_TRACKING = import.meta.env.VITE_ENV === 'local';
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string;
export const SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE as string;
export const SENTRY_ENVIRONMENT = import.meta.env
  .VITE_SENTRY_ENVIRONMENT as string;
export const AZURE_CLIENT_ID = import.meta.env.VITE_AZURE_CLIENT_ID as string;
export const AZURE_TENANT_ID = import.meta.env.VITE_AZURE_TENANT_ID as string;
export const AZURE_API = import.meta.env.VITE_AZURE_API as string;
export const REDIRECT_URL = import.meta.env.VITE_REDIRECT_URL as string;
export const CODES_API_CLIENT_ID = import.meta.env
  .VITE_CODES_API_CLIENT_ID as string;
export const CODES_API_URL = import.meta.env.VITE_CODES_API_URL as string;
export const FRONTEND_API_URL = import.meta.env.VITE_FRONTEND_API_URL as string;
export const API_TO_URL = import.meta.env.VITE_API_TO_URL as string;
export const IMAGES_API_URL = import.meta.env.VITE_IMAGES_API_URL as string;
export const INFORMERA_API_URL = import.meta.env
  .VITE_INFORMERA_API_URL as string;
export const INFORMERA_API_CLIENT_ID = import.meta.env
  .VITE_INFORMERA_API_CLIENT_ID as string;
